import React, { useState } from 'react';

export default function ThinkyIOTRPC({ onBack }) {
  const [devices] = useState([
    { id: 1, name: 'Device A', status: 'Online' },
    { id: 2, name: 'Device B', status: 'Offline' },
    { id: 3, name: 'Device C', status: 'Online' },
  ]);

  const [logs, setLogs] = useState([]);

  const sendRPC = (deviceName, command) => {
    const logEntry = {
      id: logs.length + 1,
      device: deviceName,
      command,
      time: new Date().toLocaleTimeString(),
      result: Math.random() > 0.2 ? 'Success' : 'Failed',
    };
    setLogs(prev => [logEntry, ...prev.slice(0, 19)]);
  };

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Remote Control & RPC</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {devices.map(device => (
          <div key={device.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{device.name}</h3>
            <p>Status: <span className={`${device.status==='Online' ? 'text-green-400' : 'text-red-500'} font-semibold`}>{device.status}</span></p>

            <div className="mt-3 flex gap-2">
              <button onClick={() => sendRPC(device.name, 'Restart')} className="px-3 py-1 bg-blue-600 rounded hover:bg-blue-500">Restart</button>
              <button onClick={() => sendRPC(device.name, 'Ping')} className="px-3 py-1 bg-blue-600 rounded hover:bg-blue-500">Ping</button>
            </div>
          </div>
        ))}
      </div>

      <section>
        <h2 className="text-lg font-semibold mb-3">RPC Logs</h2>
        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm max-h-64 overflow-y-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr>
                <th className="px-2 py-1">Device</th>
                <th className="px-2 py-1">Command</th>
                <th className="px-2 py-1">Result</th>
                <th className="px-2 py-1">Time</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id} className="border-t border-neutral-800">
                  <td className="px-2 py-1">{log.device}</td>
                  <td className="px-2 py-1">{log.command}</td>
                  <td className={`px-2 py-1 ${log.result==='Success' ? 'text-green-400' : 'text-red-500'}`}>{log.result}</td>
                  <td className="px-2 py-1">{log.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
